import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { errorCodeSelector } from './store/selector';
import { transactionsService } from './services/api';
import { TransactionsRequest } from './interfaces/tansactions';
import {
  postTransactionsInitApiAction,
  getTransactionFailureApiAction,
  postTransactionsSuccessApiAction,
  transactionsClearAction
} from './store/reducer';
export function useTransactionsCore() {
  const errorCode = useSelector(errorCodeSelector);
  const dispatch = useDispatch();

  const postTransactions = useCallback(
    async (id:number, transactions: TransactionsRequest[], onSuccess?: () => void) => {
      try {
        dispatch(postTransactionsInitApiAction(transactions));
        const res = await transactionsService.postTransactions(id, transactions);
        dispatch(postTransactionsSuccessApiAction(res));
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        dispatch(
          getTransactionFailureApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const clearTransactions = useCallback(() => {
    dispatch(transactionsClearAction());
  }, [dispatch]);

  return {
    errorCode,
    postTransactions,
    clearTransactions,
  };
}
